import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { selectOwnPlayerId } from "../../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionSetPurchasePackageInfo, TypeActionPackageInfo, } from "../actionSetPurchasePackageInfo";
export var epicSetPurchasePackageInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPackageInfo.RequestPurchaseInfo), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        return deps.netSend({
            id: CommandCode.PackagePurchaseInfo,
            props: {
                packageIds: action.ids,
                playerId: playerId,
            },
        });
    }), retry(), map(function (res) { return actionSetPurchasePackageInfo(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/purchase-packages/epics/epicSetPurchasePackageInfo.ts
// module id = 1963
// module chunks = 3